import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import ModalManager from "../../shared/modal";
import Auth from "../../shared/auth";
import i18n from "../../shared/i18n/i18n";
import Modal_Confirm_Delete from "../../shared/components/modal_confirm_delete";
import DateUtilities from "../../shared/utilities/date_utilities";

let categories = [];
let loading = false;
let searchQuery = "";
let sortCol = "name";
let sortAsc = true;

// Inline add
let addingName = "";
let addingSaving = false;
let addInputDom = null;

// Inline edit
let editingId = null;
let editingName = "";
let editingSaving = false;

let fetchedCourses = {};

const CoursesModal = {
    showBottomFade: true,
    oninit: function () {
        CoursesModal.showBottomFade = true;
    },
    view: function (vnode) {
        const { courses, loading } = vnode.attrs;
        return m(".modal-body", [
            m(".text-bolder.pb-1", i18n.t("courses")),
            loading
                ? m(".padding.text-center", m(".loading-dots"))
                : courses && courses.length > 0
                    ? m("div", { style: "position: relative;" }, [
                        m("ul", {
                            style: "list-style: none; margin: 0; padding: 0; max-height: 300px; overflow-y: auto;",
                            oncreate: function (v) {
                                CoursesModal.showBottomFade = v.dom.scrollHeight > v.dom.clientHeight;
                                m.redraw();
                            },
                            onscroll: function (e) {
                                const el = e.target;
                                CoursesModal.showBottomFade = el.scrollTop + el.clientHeight < el.scrollHeight - 4;
                                m.redraw();
                            }
                        }, courses.map(function (name) {
                            return m("li", { style: "padding: 0.4rem 0; border-bottom: 1px solid var(--border-color, #f3f4f6);" }, name);
                        })),
                        CoursesModal.showBottomFade
                            ? m("div", { style: "position: absolute; bottom: 0; left: 0; right: 0; height: 40px; background: linear-gradient(to bottom, transparent, var(--lighter, white)); pointer-events: none;" })
                            : null
                    ])
                    : m(".text-gray.padding", i18n.t("no_courses"))
        ]);
    }
};

function loadCategories() {
    loading = true;
    Requester.get(Gateway.admin + "courses/custom-categories")
        .then(function (result) {
            categories = result && result.properties && result.properties.categories
                ? result.properties.categories
                : [];
        })
        .catch(function (error) {
            var code = error && error.response && error.response.properties && error.response.properties.errorCode;
            Toasts.add("error", i18n.t("error"), code ? i18n.t(code) : (error && error.response && error.response.properties && error.response.properties.message) || i18n.t("unknown_error"));
        })
        .finally(function () {
            loading = false;
        });
}

function createInline() {
    if (!addingName || !addingName.trim()) {
        Toasts.add("error", i18n.t("error"), i18n.t("name_required"));
        return;
    }
    addingSaving = true;
    Requester.post(Gateway.admin + "courses/custom-categories", { name: addingName.trim() })
        .then(function () {
            addingName = "";
            Toasts.add("success", i18n.t("saved_changes"), "");
            loadCategories();
            if (addInputDom) { addInputDom.value = ""; addInputDom.focus(); }
        })
        .catch(function (error) {
            const code = error && error.response && error.response.properties && error.response.properties.errorCode;
            Toasts.add("error", i18n.t("error"), i18n.t(code === "CategoryNameAlreadyExists" ? "category_name_already_exists" : code || "unknown_error"));
        })
        .finally(function () {
            addingSaving = false;
        });
}

function startEdit(cat) {
    editingId = cat.id;
    editingName = cat.name;
    editingSaving = false;
}

function cancelEdit() {
    editingId = null;
    editingName = "";
}

function saveEdit() {
    if (!editingName || !editingName.trim()) {
        Toasts.add("error", i18n.t("error"), i18n.t("name_required"));
        return;
    }
    editingSaving = true;
    Requester.put(Gateway.admin + "courses/custom-categories/" + editingId, { id: editingId, name: editingName.trim() })
        .then(function () {
            cancelEdit();
            Toasts.add("success", i18n.t("saved_changes"), "");
            loadCategories();
        })
        .catch(function (error) {
            editingSaving = false;
            const code = error && error.response && error.response.properties && error.response.properties.errorCode;
            Toasts.add("error", i18n.t("error"), i18n.t(code === "CategoryNameAlreadyExists" ? "category_name_already_exists" : code || "unknown_error"));
        });
}

function openCoursesModal(cat) {
    let modalState = { courses: null, loading: true };
    if (fetchedCourses[cat.id] !== undefined) {
        modalState = { courses: fetchedCourses[cat.id], loading: false };
    } else {
        Requester.get(Gateway.admin + "courses/custom-categories/" + cat.id + "/courses")
            .then(function (result) {
                fetchedCourses[cat.id] = result.courseNames || [];
                modalState.courses = fetchedCourses[cat.id];
                modalState.loading = false;
                m.redraw();
            })
            .catch(function () {
                fetchedCourses[cat.id] = [];
                modalState.courses = [];
                modalState.loading = false;
                m.redraw();
            });
    }
    ModalManager.open(cat.name, [], CoursesModal, modalState);
}

function confirmDelete(category) {
    const courseCount = category.courseCount || 0;
    const countSentence = courseCount > 0
        ? i18n.t("sure_to_delete_category_applied", { count: courseCount })
        : i18n.t("sure_to_delete_category_none");
    const deleteText = m("span", [
        i18n.t("sure_to_delete_category_prefix"), ' "', m("strong", category.name), '"? ',
        countSentence, " ",
        i18n.t("sure_to_delete_category_suffix")
    ]);
    ModalManager.open(i18n.t("delete_category"), [], Modal_Confirm_Delete, {
        callback: function () { deleteCategory(category.id); },
        text: deleteText,
        btnText: i18n.t("delete")
    });
}

function deleteCategory(id) {
    Requester.delete(Gateway.admin + "courses/custom-categories/" + id)
        .then(function () {
            Toasts.add("success", i18n.t("category_deleted"), "");
            loadCategories();
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response && error.response.properties && error.response.properties.errorCode || "unknown_error"));
        });
}

function toggleSort(col) {
    if (sortCol === col) {
        sortAsc = !sortAsc;
    } else {
        sortCol = col;
        sortAsc = true;
    }
}

function sortIcon(col) {
    const isActive = sortCol === col;
    return m("i.icon-forward.align-middle", {
        style: "font-size: 0.95rem; margin-left: 5px; transition: opacity 0.15s;" + (isActive ? "opacity: 1;" : "opacity: 0.25;"),
        class: isActive ? (sortAsc ? "rotate-90" : "rotate-270") : "rotate-90"
    });
}

function filteredCategories() {
    const q = searchQuery.toLowerCase();
    const filtered = searchQuery
        ? categories.filter(function (c) { return c.name && c.name.toLowerCase().indexOf(q) !== -1; })
        : categories.slice();

    filtered.sort(function (a, b) {
        if (sortCol === "courseCount") {
            const valA = a.courseCount || 0;
            const valB = b.courseCount || 0;
            return sortAsc ? valA - valB : valB - valA;
        }
        const valA = a[sortCol] != null ? String(a[sortCol]).toLowerCase() : "";
        const valB = b[sortCol] != null ? String(b[sortCol]).toLowerCase() : "";
        return sortAsc ? valA.localeCompare(valB) : valB.localeCompare(valA);
    });

    return filtered;
}

function thAttrs(col, extraStyle) {
    const isActive = sortCol === col;
    return {
        onclick: function () { toggleSort(col); },
        style: (isActive ? "font-weight: 700; " : "") + (extraStyle || ""),
        class: "c-hand"
    };
}

const Component_Organisation_Customisation = {
    oninit: function () {
        searchQuery = "";
        addingName = "";
        editingId = null;
        fetchedCourses = {};
        loadCategories();
    },
    view: function () {
        const canManage = Auth.validateRights(["courses_manage_categories"]);
        const visible = filteredCategories();
        const span = canManage ? 5 : 4;

        return [
            m(".content-box", [
                m("h3", i18n.t("course_categories")),
                m(".toolbar", [
                    m(".toolbar-section", [
                        m(".text-gray text-sm mt-1", i18n.t("custom_categories_intro"))
                    ]),
                    m(".toolbar-section", [
                        m(".has-icon-right", [
                            m("input[type=search]", {
                                placeholder: i18n.t("search"),
                                value: searchQuery,
                                oninput: function () { searchQuery = this.value; },
                                onkeydown: function (e) { if (e.key === "Escape") { searchQuery = ""; } }
                            }),
                            searchQuery
                                ? m("i.icon-x.c-hand", { onclick: function () { searchQuery = ""; } })
                                : null,
                            m("i.icon-search")
                        ])
                    ])
                ]),
                canManage
                    ?
                    m(".custom-category-panel",
                        m(".form-section p-2", { style: "border-bottom: 1px solid var(--border-color, #e5e7eb);" }, [
                            m(".text-gray text-xs mb-1", i18n.t("create_category_hint")),
                            m(".flex-row pb-2", [
                                m("input[type=text]", {
                                    placeholder: i18n.t("category_name"),
                                    value: addingName,
                                    oninput: function () { addingName = this.value; },
                                    onkeydown: function (e) { if (e.key === "Enter") createInline(); },
                                    oncreate: function (vnode) { addInputDom = vnode.dom; vnode.dom.focus(); },
                                    style: "max-width: 320px"
                                }),
                                !addingSaving
                                    ? m("button.btn-cta.ml-2.mr-2", { onclick: createInline }, i18n.t("add"))
                                    : m("button.btn-text.no-click", [i18n.t("saving"), m(".loading-dots")])
                            ])
                        ])
                    )
                    : null,
                !loading
                    ? m(".table-wrapper", [
                        m("table.full-width", [
                            m("thead", [
                                m("tr", [
                                    m("th.pl-2.c-hand", thAttrs("name"), [
                                        m("div.flex-row.justify-between", [m("span", i18n.t("name")), sortIcon("name")])
                                    ]),
                                    m("th.c-hand", thAttrs("courseCount"), [
                                        m("div.flex-row.justify-between", [m("span", i18n.t("courses")), sortIcon("courseCount")])
                                    ]),
                                    m("th.c-hand", thAttrs("createdBy"), [
                                        m("div.flex-row.justify-between", [m("span", i18n.t("created_by")), sortIcon("createdBy")])
                                    ]),
                                    m("th.c-hand", thAttrs("createdOn"), [
                                        m("div.flex-row.justify-between", [m("span", i18n.t("created_on")), sortIcon("createdOn")])
                                    ]),
                                    canManage ? m("th", "") : null
                                ])
                            ]),
                            m("tbody", [
                                visible.length > 0
                                    ? visible.map(function (cat) {
                                        const isEditing = editingId === cat.id;

                                        if (isEditing) {
                                            return m("tr.custom-category-panel", [
                                                m("td.pl-2", { colSpan: 4 }, [
                                                    m(".text-gray form-section text-sm mt-2", i18n.t("edit_category_hint")),
                                                    m(".flex-row.form-section.text-sm", [
                                                        m("input[type=text]", {
                                                            value: editingName,
                                                            oninput: function () { editingName = this.value; },
                                                            onkeydown: function (e) {
                                                                if (e.key === "Enter") saveEdit();
                                                                if (e.key === "Escape") cancelEdit();
                                                            },
                                                            oncreate: function (vnode) { vnode.dom.focus(); vnode.dom.select(); }
                                                        }),
                                                        !editingSaving
                                                            ? ''
                                                            : m("button.btn-text.no-click", [i18n.t("saving"), m(".loading-dots")])
                                                    ])
                                                ]),
                                                m("td.text-right", [
                                                    m(".flex-row.pr-2", { style: "justify-content: flex-end; gap: 0.4rem" }, [
                                                        !editingSaving
                                                            ? m("button.btn-yes", { onclick: saveEdit }, [m("i.icon-check."), i18n.t("save")])
                                                            : m("button.btn-text.no-click", [i18n.t("saving"), m(".loading-dots")]),
                                                        m("button", { onclick: cancelEdit }, [m("i.icon-close"), i18n.t("cancel")])
                                                    ])
                                                ])
                                            ]);
                                        }

                                        return m("tr", [
                                            m("td.pl-2.text-bolder", cat.name),
                                            m("td", [
                                                cat.courseCount != null ? cat.courseCount : "-",
                                                cat.courseCount > 0
                                                    ? m("span", { style: "display: inline-block; margin-left: 5px; vertical-align: middle" }, [
                                                        m("span", {
                                                            style: "display: inline-flex; align-items: center; justify-content: center; width: 15px; height: 15px; border-radius: 50%; border: 1.5px solid var(--color-primary, #3b82f6); font-size: 0.65rem; font-weight: 700; color: var(--color-primary, #3b82f6); cursor: pointer; line-height: 1; font-style: italic",
                                                            onclick: function () { openCoursesModal(cat); }
                                                        }, "i")
                                                    ])
                                                    : null
                                            ]),
                                            m("td", cat.createdBy || "-"),
                                            m("td", cat.createdOn ? DateUtilities.getFormattedDateFromUTC(cat.createdOn) : "-"),
                                            canManage
                                                ? m("td.text-right", [
                                                    m(".flex-row", { style: "justify-content: flex-end; gap: 0.4rem" }, [
                                                        m("button.btn-text.with-icon", { onclick: function () { startEdit(cat); } }, [m("i.icon-edit"), i18n.t("edit")]),
                                                        m("button.btn-text.with-icon.text-danger", { onclick: function () { confirmDelete(cat); } }, [m("i.icon-bin"), i18n.t("delete")])
                                                    ])
                                                ])
                                                : null
                                        ]);
                                    })
                                    : m("tr", [
                                        m("td.text-gray.padding", { colspan: span }, searchQuery ? i18n.t("no_results") : i18n.t("no_categories"))
                                    ])
                            ])
                        ])
                    ])
                    : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")]),
                m(".padding.text-gray", { style: "font-size: 0.875rem; border-top: 1px solid var(--border-color, #e5e7eb); margin-top: 0.5rem; padding-top: 0.75rem" }, [
                    m("strong", i18n.t("note")), " ", i18n.t("custom_categories_footer")
                ])
            ])
        ];
    }
};

export default Component_Organisation_Customisation;
